
    var riot = require('riot')
    //src: starling/src/tags/perspectives-listing.html
riot.tag2('perspectives-listing',
  '<section ref="main" class="side-tab side-tab--expanded"> <header ref="perspectiveHeader" class="side-tab_header"> <span class="side-tab_header_logo"> <i class="side-tab_header_icon material-icons">visibility</i> </span> <h3 class="side-tab_header_title">Perspectives</h3> <i class="side-tab_header_help side-tab_header_icon material-icons" onclick="{openPerspectivesHelp}">help</i> <button ref="perspectiveSettingsButton" class="side-tab_header_menu floating-menu_button" onclick="{toggleToolMenu}"> <i class="material-icons floating-menu_button_icon">more_vert</i> </button> </header> <div ref="containerTags" class="side-tab_body"> <perspectives-listing-item canvas="{parent.canvas}" each="{this.getPerspectives()}"></perspectives-listing-item> <p if="{!getPerspectives().length}" class="side-tab_body_empty">Use perspectives to explain cards from alternative points of view.</p> </div> <footer class="side-tab_footer"> <button if="{!canvas.isViewOnly()}" ref="addButton" class="side-tab_action Button Button--Plain Button--Full" onclick="{createEmptyPerspective}"> <svg class="Button__Icon"> <use xlink:href="#add-circle-outline-icon"></use> </svg> <span class="Button__Label">Add a perspective</span> </button> </footer> </section>',
  '',
  'class="side-tab_container"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _perspectivesUi = require('lib/perspectives-ui');

var _perspectiveCreationUi = require('lib/perspective-creation-ui');

var _Sortable = require('sortablejs/Sortable.js');

var _Sortable2 = _interopRequireDefault(_Sortable);

var _lodash = require('lodash.sortby');

var _lodash2 = _interopRequireDefault(_lodash);

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

this.canvas = canvas;
canvas.perspectivesListingTag = this;

this.toggleToolMenu = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  if (_this.toolMenuOpened && _this.canvas.perspectiveSettingsMenu.summoned) {
    _this.canvas.perspectiveSettingsMenu.hide();
    _this.toolMenuOpened = false;
  } else {
    _this.canvas.hidePopups();
    _this.canvas.perspectiveSettingsMenu.show({
      spawnedFromElement: _this.refs.perspectiveSettingsButton
    });
    _this.toolMenuOpened = true;
  }
};

this.getPerspectives = function () {
  return _perspectivesUi.pui.getPerspectives();
};

this.createEmptyPerspective = function () {
  if (_perspectivesUi.pui.hasPersistentPerspective()) {
    _perspectivesUi.pui.unsetAllPerspectives();
  }
  var perspective = _perspectivesUi.pui.addPerspectivePoint({
    label: '',
    color: _perspectiveCreationUi.pcui.findNextUnusedColor()
  });
  _this.update();
  var listingItem = _this.getListingItem(perspective.id);
  if (listingItem) {
    listingItem.startEditing();
  }
};

this.stopEditing = function () {
  _this.canvas.perspectivesListingItemToolMenuTag.hide();
  if (_this.editing) {
    _perspectivesUi.pui.getPerspectiveListingItemTags().forEach(function (tag) {
      if (tag) {
        tag.stopEditing();
      }
    });
    _this.editing = false;
  }
};

this.getListingItem = function (perspectiveId) {
  return _this.getListingItems().find(function (l) {
    return l.id == perspectiveId;
  });
};

this.getListingItems = function () {
  if (_this.tags['perspectives-listing-item']) {
    if (_this.tags['perspectives-listing-item'].length) {
      return _this.tags['perspectives-listing-item'];
    }
    return [_this.tags['perspectives-listing-item']];
  }
  return [];
};

this.stickPerspectiveSettingsMenuButton = function () {
  _this.refs.perspectiveSettingsButton.classList.add('active');
};

this.unstickPerspectiveSettingsMenuButton = function () {
  _this.refs.perspectiveSettingsButton.classList.remove('active');
};

this.on('mount', function (e) {
  var container = _this.refs.containerTags;

  new _Sortable2.default(container, {
    animation: 150,
    ghostClass: 'side-tab_item--dropzone',
    onStart: function onStart() {
      document.body.classList.add('side-tab_item--dragging');
    },
    onEnd: function onEnd(evt) {
      var prevPs = (0, _lodash2.default)(_store_instance2.default.perspectives, 'orderIndex');
      var sortedPs = _store_instance2.default.updateLegendOrderIndexes(evt.oldIndex, evt.newIndex);
      _this.canvas.operation.editPerspectivesOrderCollection({ sortedPs: sortedPs, prevPs: prevPs });
      document.body.classList.remove('side-tab_item--dragging');
      _this.update();
      for (var _iterator = _store_instance2.default.perspectives, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var p = _ref;

        _perspectivesUi.pui.updatePerspectiveNodeTagsDots(p.id);
      }
    }
  });
});

this.openPerspectivesHelp = function (event) {
  event.stopPropagation();
  canvas.openSidebar('user-guide');
  canvas.userGuideTag.openItem('what-is-p');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspectives-listing')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspectives-listing.html
// module id = 651
// module chunks = 0